import { createContext } from 'react'
import { BrokerConfig, MQTTClient } from '@frontend/core'

export type BrokerConfigMap = {
  [host: string]: BrokerConfig
}

export const MQTTContext = createContext<{
  client: MQTTClient | null
  isConnected: boolean
  localMSConnectionStatus: boolean
  externalConnections: BrokerConfig[]
}>({
  client: null,
  localMSConnectionStatus: false,
  isConnected: false,
  externalConnections: []
})
